// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3TD8T","inner":"Footer_inner__1gqa1","nextIcon":"Footer_nextIcon__49_dA","innerLeft":"Footer_innerLeft__N2CKY"};